import type { DateTime } from "luxon"

import { useDateTime } from "../../../../../../localization/useDateTime"

import type { MeetingRowOrder } from "../../../weekMenuTypes"

type MeetingTiming = Readonly<{
    start: DateTime | null
    end: DateTime | null
    isInProgress: boolean
    minutesLeft: number
    hoursLeft: number
    minutesLeftRemainder: number
}>

export function useMeetingTiming(meeting: MeetingRowOrder, now: DateTime): MeetingTiming {
    const dateTimeFactory = useDateTime()
    const { meetingDetails, deliveryDetails } = meeting

    const startStr = meetingDetails.startDateTime || deliveryDetails.time || ""
    const start = startStr ? dateTimeFactory.fromApi(startStr) : null
    const end = meetingDetails.endDateTime ? dateTimeFactory.fromApi(meetingDetails.endDateTime) : null

    const isInProgress = Boolean(start?.isValid && end?.isValid && now >= start && now < end)
    const minutesUntilEnd = end?.isValid ? end.diff(now, "minutes").minutes : 0
    const minutesLeft = Math.max(1, Math.ceil(minutesUntilEnd))
    const hoursLeft = Math.floor(minutesLeft / 60)
    const minutesLeftRemainder = minutesLeft % 60

    return { start, end, isInProgress, minutesLeft, hoursLeft, minutesLeftRemainder }
}
